import { ensureString } from 'ensure-string';
import Papa from 'papaparse';
import { Analysis } from '../index.js';
/**
 * @param text
 * @param arrayBuffer
 * @returns - New class element with the given data
 */
export function fromPerkinElmerCSV(arrayBuffer) {
    const text = ensureString(arrayBuffer);
    const parsed = Papa.parse(text, {
        skipEmptyLines: true,
        header: true,
        dynamicTyping: true,
    }).data;
    const analysis = new Analysis();
    analysis.pushSpectrum({
        x: {
            data: parsed.map((d) => d['Sample Temperature']),
            label: 'Sample Temperature [°C]',
            isDependent: true,
        },
        y: {
            data: parsed.map((d) => d['Unsubtracted Heat Flow']),
            label: 'Heat Flow [mW]',
            isDependent: true,
        },
        p: {
            data: parsed.map((d) => d['Program Temperature']),
            label: 'Program Temperature [°C]',
            isDependent: true,
        },
        t: {
            data: parsed.map((d) => d.Time),
            label: 'Time [min]',
            isDependent: false,
        },
    }, { dataType: 'DSC' });
    return analysis;
}
//# sourceMappingURL=fromPerkinElmerCSV.js.map